import Vuex from 'vuex'
import Vue from 'vue';
import CapturaService from "../services/CapturaService";

Vue.use(Vuex)

let initialState = {
    URLRETORNO: null,
    chave: null,
    cod_usuario:null,
    id_link:null,
    num_telefone_celular: null,
    pdv: null,
    cpf:null,
    url:null,
    url_ativa:false,
    tipo_selfie:null,
    tipo_captura:null,
    origem_processo: null,
    licenca_kofax:null,
    loadingStatus:false,
    titulo: null,
    tip_captura: null,
    tipo_doc:null,
    tip_solicitacao:null,
    url_webhook:null,
    componente_selfie_carregado:false,
    componente_doc_carregado:false,
    cnh_digital_base:null,
    link_codigo: null,
    link_hrefer: null,
    link_origem: null,
    liveness:3 // 1 - 2D 2 - Facetec 3 - LivenessSerasa
};

const state = initialState;

const mutations = {
    DEFINIR_LINK_VALIDO(state, payload){
        state.URLRETORNO = payload.URLRETORNO;
        state.chave = payload.chave;
        state.cod_usuario = payload.cod_usuario;
        state.id_link = payload.id_link;
        state.num_telefone_celular = payload.num_telefone_celular;
        state.pdv = payload.pdv;
        state.cpf = payload.cpf;
        state.url = payload.url;
        state.licenca_kofax = payload.licenca_kofax;
        state.tipo_selfie = payload.tipo_selfie;
        state.tipo_captura = payload.tipo_captura;
        state.tip_captura = payload.tip_captura;
        state.tipo_doc = payload.tipo_doc;
        state.tip_solicitacao = payload.tip_solicitacao;
        state.url_webhook = payload.url_webhook;
        state.origem_processo = payload.origem_processo;
    },
    DEFINIR_URL_ATIVA(state,urlAtiva){
        state.url_ativa = Boolean(urlAtiva);
    },
    RESET_STATE(state) {
        state = initialState;
    },
    LOADING_STATUS(state,status){
        state.loadingStatus = Boolean(status);
    },
    SET_TITULO(state,titulo){
        state.titulo = titulo;
    },
    DEFINIR_TIPO_DOC(state,tipo){
        state.tipo_doc = tipo;
    },
    DEFINIR_COMPONENTE_SELFIE_CARREGADO(state,status){
        state.componente_selfie_carregado = Boolean(status);
    },
    DEFINIR_COMPONENTE_DOC_CARREGADO(state,status){
        state.componente_doc_carregado = Boolean(status);
    }
};

const actions = {
    resetState({commit}){
        commit('RESET_STATE');
    },
    recuperarDadosLinkMeuVivo({commit},payload) {
        return new Promise(((resolve, reject) => {
            let captura = new CapturaService();
            captura.recuperarDadosLinkMeuVivo(payload.codigo,payload.hrefer,payload.origem)
                .then(res => {
                    if(res.type === captura.types.error){
                        reject(res.description);
                    }
                    if(res.data.length === 0){
                        reject('Dados do link não encontrados');
                    }
                    let tipo_doc = sessionStorage.getItem('tipd');
                    if(tipo_doc){
                        res.data.tipo_doc = atob(tipo_doc);
                    }

                    state.link_codigo = payload.codigo;
                    state.link_hrefer = payload.hrefer;
                    state.link_origem = payload.origem;

                    commit('DEFINIR_LINK_VALIDO', res.data);
                    resolve();
                }).catch(e => reject('Falha ao recuperar dados do link'));
        }));
    },
    setLoadingStatus({commit},status){
        commit('LOADING_STATUS',status);
    },
    setUrlAtiva({commit},status){
        commit('DEFINIR_URL_ATIVA',status);
    },
    setTitulo({commit},titulo){
        commit('SET_TITULO',titulo);
    },
    setTipoDoc({commit},tipo){
        commit('DEFINIR_TIPO_DOC',tipo);
    },
    definirComponenteSelfieCarregado({commit},status){
        commit('DEFINIR_COMPONENTE_SELFIE_CARREGADO',status);
    },
    definirComponenteDocCarregado({commit},status){
        commit('DEFINIR_COMPONENTE_DOC_CARREGADO',status);
    },
};

const getters = {
    loadingStatus(state) {
        return state.loadingStatus;
    },
    urlStatus(state) {
        return state.url_ativa;
    },
    dados(state){
        return state;
    },
    tipoCaptura(state){
        return parseInt(state.tip_captura);
    },
    tipoDoc(state){
        return state.tipo_doc;
    },
    getUser(state){
        return state.cod_usuario;
    },
    getUrlRetorno(state){
        return state.URLRETORNO;
    },
    getUrlWebhook(state){
        return state.url_webhook;
     },
    origemProcesso(state){
        return state.origem_processo;
    },
    isJornadaCompleta(state){
        return state.tip_captura == 1 ? true : false;
    },
    componenteSelfieCarregado(state){
        return state.componente_selfie_carregado;
    },
    componenteDocCarregado(state){
        return state.componente_doc_carregado;
    }
};
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})



// WEBPACK FOOTER //
// ./src/store/store.js